import './i18n';
import App from 'App';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';
import 'assets/fonts/fonts.css';
import { logger } from 'lib/logger';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

async function enableMocking() {
  logger.info('MSW: Checking if mocking should be enabled...');
  const isMswEnabled = import.meta.env.VITE_ENABLE_MSW || sessionStorage.getItem('VITE_ENABLE_MSW');
  logger.info('MSW: ENABLE_MSW value:', isMswEnabled);

  if (isMswEnabled !== 'true') {
    logger.info('MSW: Mocking disabled');
    return;
  }

  logger.info('MSW: Mocking enabled, initializing worker...');
  const { worker } = await import('./mocks/browser');
  return worker
    .start({
      onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
    })
    .then(function onWorkerStarted() {
      logger.info('MSW: Worker started successfully');
    })
    .catch(function onWorkerError(error) {
      logger.error('MSW: Failed to start worker:', error);
    });
}

const root = createRoot(container);

enableMocking()
  .then(() => {
    logger.info('MSW: App starting...');
    root.render(
      <Provider store={store}>
        <App />
      </Provider>,
    );
  })
  .catch((error) => {
    logger.error('MSW: Failed to initialize app:', error);
  });
